import { http } from '@article/pixel';
import { formatMoney } from './utils.js';

export default class PayBrightUtils {
  static load(key, url, modalUrl) {
    if (window.paybrightConfig) {
      return;
    }
    window.paybrightConfig = {
      key,
      url,
      modalUrl,
    };
  }

  static estimatePayment(amount, config, hidePricing) {
    PayBrightUtils.load(config.paybrightKey, config.paybrightUrl, config.paybrightModalUrl);
    return new Promise((resolve, reject) => {
      try {
        if (hidePricing) {
          resolve({
            modalUrl: PayBrightUtils.modalUrl(amount, hidePricing),
          });
        }
        
        const formattedAmount = formatMoney('', amount);
        PayBrightUtils.fetchEstimate(formattedAmount).then((data) => {
          if (data.monthlyPayment) {
            resolve({
              dollars: data.monthlyPayment,
              perMonth: `As low as $${data.monthlyPayment}/month`,
              perMonthPriceOnly: data.monthlyPayment,
              modalUrl: PayBrightUtils.modalUrl(formattedAmount),
            });
          } else {
            resolve({});
          }
        });
      } catch (error) {
        console.error(error);
        resolve({});
      }
    });
  }

  static modalUrl(amount, hidePricing) {
    if (hidePricing) return `${window.paybrightConfig.modalUrl}?public_key=${window.paybrightConfig.key}`;
    return `${window.paybrightConfig.modalUrl}?public_key=${window.paybrightConfig.key}&purchase_amount=${amount}`;
  }

  static async fetchEstimate(amount) {
    try {
      const result = await http.post(
        window.paybrightConfig.url,
        {
          accountid: window.paybrightConfig.key,
          amount,
        },
        null,
        {
          credentials: 'same-origin',
        },
      );

      if (result && result.length) {
        return { monthlyPayment: result[0].MonthlyPayment };
      }
    } catch (error) {
      console.error(error);
      return {};
    }
  }
}
